import { useState } from 'react';
import { cn } from '~/util';
import { useFieldContext } from '~/util/hooks/useFormContext';
import { CountrySelector } from '../../ItemSelector';
import {
    FieldLabelWithError,
    FieldWithErrorProps,
} from './FieldLabelWithError';
import { useDisableFormContext } from '../DisableContext';
import { Button } from '~/primitives/button';
import Flag from '~/partials/Flag';
import { fromNumeric, getCountryName } from '~/util/countries';

export function CountryField({
    placeholder,
    classname,
    forceDisabled,
    ...labelProps
}: {
    placeholder: string;
    forceDisabled?: boolean;
    classname?: string;
} & FieldWithErrorProps) {
    const field = useFieldContext<number | null>();
    const [countrySelectorOpen, setCountrySelectorOpen] = useState(false);
    const disabled = useDisableFormContext() || forceDisabled;
    return (
        <FieldLabelWithError<number | null> {...labelProps}>
            <Button
                variant="outline"
                className={cn(
                    'w-fit',
                    classname,
                    disabled && 'opacity-50 cursor-not-allowed',
                )}
                type="button"
                disabled={disabled}
                onClick={() => setCountrySelectorOpen(true)}
            >
                <span className="text-secondary-foreground flex gap-2 items-center">
                    {!field.state.value ? (
                        'None'
                    ) : (
                        <>
                            <Flag countryCode={field.state.value} />
                            {(field.state.value &&
                                getCountryName(
                                    fromNumeric(field.state.value),
                                )) ||
                                placeholder}
                        </>
                    )}
                </span>
            </Button>
            <CountrySelector
                open={countrySelectorOpen}
                onOpenChange={setCountrySelectorOpen}
                single
                initial={
                    !field.state.value
                        ? undefined
                        : fromNumeric(
                              String(field.state.value).padStart(3, '0'),
                          )
                }
                onSave={(selectedCountry) => {
                    field.handleChange(
                        selectedCountry
                            ? Number(selectedCountry.numeric)
                            : null,
                    );
                }}
            />
        </FieldLabelWithError>
    );
}
